import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { CommonModule } from '@angular/common';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, FormArray, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ErrorStateMatcher } from '@angular/material/core';
import {AppSettingsService} from '../services/appsettings.service';
import {AppSettings} from '../app.settings';


/*
export class MyErrorStateMatcher 


implements ErrorStateMatcher {


  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }


}*/


@Component({
    selector: 'app-resetpassword-view',
    templateUrl: './resetpassword.component.html',
    styleUrls: ['./resetpassword.component.css']
})
export class ResetPasswordComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;
    emailid;
    formdata;
    loginForm: UntypedFormGroup;
    isCompleted: true;
    token: string;
    email: string;
    hidelogin = false;
    hideconfirm = true;
    private settings: AppSettings;
    enrollURL: string;


    ResetForm: UntypedFormGroup;
  //  matcher = new MyErrorStateMatcher();




  matcher: ErrorStateMatcher = {
      isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
        const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

        return (invalidCtrl || invalidParent);
      }
    };

    validate: ErrorStateMatcher = {
      isErrorState: (control: UntypedFormControl) => {
        return true;
      }
    };


    constructor(private route: ActivatedRoute,
                private router: Router,
                private formBuilder: UntypedFormBuilder,
                private appSettingsService: AppSettingsService,
                private authenticationService: AuthenticationService) {

                  this.appSettingsService.getSettings().subscribe(settings => this.settings = settings,
                    () => null,
                    () => {
                      this.enrollURL = this.settings.enrollServer;
                    });

                }


    ngOnInit() {
        this.loading = false;
        // this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        // this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/home/tabs';

        this.token = this.route.snapshot.queryParams.token;
        this.email = this.route.snapshot.queryParams.email;

        this.initForm();

    }

    get f() { return this.ResetForm.controls; }


    initForm() {

        this.ResetForm = this.formBuilder.group({
         // tslint:disable-next-line: max-line-length
          Password: ['', [Validators.required, Validators.minLength(6), Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]],
          // tslint:disable-next-line: max-line-length
          ConfirmPassword: ['', [Validators.required, Validators.minLength(6), Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]],
          Token: [this.token, [Validators.required]],
          Email: [this.email, [Validators.required]]
        }, {validator: this.checkPasswords },
        );


      }





  resetpword(fdata) {

    if (fdata.Password === '' || fdata.ConfirmPassword === '') {

      Object.keys(this.ResetForm.value).forEach(field => {
        const control = this.ResetForm.controls[field];
        control.markAsTouched();
        control.updateValueAndValidity();
      });
    }


    if (this.ResetForm.valid) {


    this.loading = true;
    this.authenticationService.resetpword(fdata)
        .subscribe(
            data => {

                const user = data;

                this.loading = false;
                this.hidelogin = true;
                this.hideconfirm = false;


            },
            error => {
                this.loading = false;
                //  alert("Error Test");
            });

    } else {
      // validate all form fields


    }

    }


  checkPasswords(group: UntypedFormGroup) { // here we have the 'passwords' group
  const pass = group.get('Password').value;
  const confirmPass = group.get('ConfirmPassword').value;

  return pass === confirmPass ? null : { notSame: true };
}



}
